import EditDialog from "@/components/common/EditDialog";
import { ui } from "@patient-watch/ui";
import { LOCALE_LABELS, SUPPORTED_LOCALES, type SupportedLocale } from "@patient-watch/i18n";
import { useProfileCopy } from "./profileCopy";
import { useSetAppLocale } from "./useSetAppLocale";

interface Props {
    userId: string;
    currentLocale: SupportedLocale;
}

export function LanguageSwitcher({ userId: _userId, currentLocale }: Props) {
    const copy = useProfileCopy();
    const setLocale = useSetAppLocale();

    return (
        <EditDialog
            label="Language / Sprache / Sprog"
            dialogTitle={copy.chooseLanguage}
            info={LOCALE_LABELS[currentLocale]}
            triggerTestId="language-trigger"
            showSaveButton={false}
        >
            <ui.Select value={currentLocale} onValueChange={(value) => setLocale(value as SupportedLocale)}>
                <ui.SelectTrigger
                    className="w-full"
                    data-testid="language-select-trigger"
                    aria-label={copy.chooseLanguage}
                >
                    <ui.SelectValue />
                </ui.SelectTrigger>
                <ui.SelectContent>
                    {SUPPORTED_LOCALES.map((locale) => (
                        <ui.SelectItem key={locale} value={locale} data-testid={`language-option-${locale}`}>
                            {LOCALE_LABELS[locale]}
                        </ui.SelectItem>
                    ))}
                </ui.SelectContent>
            </ui.Select>
        </EditDialog>
    );
}
